import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/Auth/AuthContext";
import { subscribePresence } from "./presenceSocket";

/**
 * Quem está online agora, em tempo real (#4433).
 *
 * NÃO emite mais "heartbeat". Antes, este hook mandava um heartbeat a cada 15s
 * e era ele quem fazia o backend gravar `online` no banco — só que o hook nunca
 * chegava a ser CHAMADO em lugar nenhum (estava apenas importado no chat
 * interno), então ninguém ficava online. Hoje a presença é o próprio socket
 * conectado, decidida no servidor; aqui só escutamos, para a tela mudar sem F5.
 *
 * A assinatura vive em `presenceSocket.js` (puro, testado) — regra da pasta.
 */
const useOnlineUsers = () => {
  const [onlineUsers, setOnlineUsers] = useState([]);
  const { socket } = useContext(AuthContext);

  useEffect(() => subscribePresence(socket, setOnlineUsers), [socket]);

  return onlineUsers;
};

export default useOnlineUsers;
